// angular
import {Component, OnInit, inject} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {DecimalPipe} from "@angular/common";
import {NgxSpinnerService} from "ngx-spinner";
// material angular
import {MatDialog} from "@angular/material/dialog";
// components
import {TableComponent} from "@app/core/components/table/table.component";
import {CustomerListFiltersDialogComponent} from "./customer-list-filters-dialog/customer-list-filters-dialog.component";
import {AddButtonComponent} from "@app/core/components/add-button/add-button.component";
// services
import {CustomerService} from "../shared/services/customer.service";
import {LayoutService} from "../../layout/shared/services/layout.service";
import {ScreenSizeService} from "src/app/shared/services/screen-size.service";
// types
import {ITableConfig} from "../../core/components/table/table-config.type";
import {Role} from "@app/shared/types/role.enum";
import {ScreenSizeType} from "src/app/shared/types/screen-size.type";
// directives
import {HasAccessDirective} from "@app/core/directives/has-access.directive";
import {HeaderPayloadDirective} from "@app/core/directives/header-payload.directive";
import {SortMenuGroup} from "../shared/types/customer-sort-menu.type";
import {customerSortOptionGroups} from "../shared/constants/customer-sort-options";

@Component({
  selector: "app-customers-list",
  templateUrl: "./customers-list.component.html",
  styleUrls: ["./customers-list.component.scss"],
  standalone: true,
  imports: [
    TableComponent,
    AddButtonComponent,
    HasAccessDirective,
    HeaderPayloadDirective,
  ],
})
export class CustomersListComponent implements OnInit {
  public tableConfig: ITableConfig;
  public Role = Role;
  public pageId!: string;
  public showSort = true;
  public customerSortOptionGroups: SortMenuGroup[] = customerSortOptionGroups;
  private _screenSize: ScreenSizeType;

  // dependencies
  private _customerService = inject(CustomerService);
  private _router = inject(Router);
  private _activatedRoute = inject(ActivatedRoute);
  private _decimal = inject(DecimalPipe);
  private _layoutService = inject(LayoutService);
  private _screenSizeService = inject(ScreenSizeService);
  private _spinner = inject(NgxSpinnerService);
  private _dialog = inject(MatDialog);
  constructor() {}

  ngOnInit() {
    this.showSort = !this._router.url.includes("debtors");

    this._activatedRoute.data.subscribe((data) => {
      if (data) {
        const pageId = data?.["id"];
        this.pageId = pageId;
      }
    });

    this._screenSizeService.screenSize$.subscribe(
      (size) => (this._screenSize = size)
    );

    this._activatedRoute.queryParams.subscribe(() => {
      if (this._router.url.includes("debtors")) {
        this._getAllCustomerByDebtList();
      } else {
        this._getAllCustomerList();
      }
    });
    this._customerService.updateList$.subscribe(() => {
      if (this._router.url.includes("debtors")) {
        this._getAllCustomerByDebtList();
      } else {
        this._getAllCustomerList();
      }
    });
  }

  private _getAllCustomerList() {
    this._customerService
      .getAllCustomers({is_online: !!this.pageId})
      .subscribe((res) => {
        this.tableConfig = this._customerService.getCustomersTableConfig(res);
        this._spinner.hide();
      });
  }
  private _getAllCustomerByDebtList() {
    this._customerService.getCustomersByDebt().subscribe((res) => {
      this.tableConfig = this._customerService.getCustomersTableConfig(res);
      this._layoutService.pageTitle.set(
        `لیست مشتری های بدهکار (جمع کل: ${this._decimal.transform(res.metadata.total_debt, "1.0")}  ریال)`
      );
      this._spinner.hide();
    });
  }

  public openFiltersModal() {
    this._dialog.open<CustomerListFiltersDialogComponent>(
      CustomerListFiltersDialogComponent,
      {
        maxWidth: "1000px",
        width: this._screenSize === "xSmall" ? "100vw" : "80vw",
        maxHeight: this._screenSize === "xSmall" ? "100vh" : "80vh",
      }
    );
  }
}
